import { genericFetch } from "./common-service"
import { apiBaseUrl } from "./config"
import { getBaseHeader } from "./utils"
import { BergerlevraultLocalauthority, ElementAnalytiqueBergerLevrault, AxeAnalytique, Budget } from "../../model"

const AXES = 'axesanalytiques'
const BLS = 'bergerlevraults'
const BUDGETS = 'budgets'
const ELEMENTS = 'elementsanalytiques'
const CHECKSERVER = 'checkserver'

export function findServicesBL(localAuthorityId: number): Promise<ElementAnalytiqueBergerLevrault[]> {
	const url: string = `${apiBaseUrl}/${BLS}/${localAuthorityId}/${ELEMENTS}`

	return genericFetch<ElementAnalytiqueBergerLevrault[]>(url, { headers: getBaseHeader() } )
}

export function checkServerExist(
	server: string,
	port: number,
	signal: AbortSignal
): Promise<BergerlevraultLocalauthority[]>{
	const url: string = `${apiBaseUrl}/${BLS}/${CHECKSERVER}`
	const infos = { port, server }
	const body = JSON.stringify(infos)
	const init: RequestInit = {
		body,
		headers: { ...getBaseHeader(), 'Content-Type': 'application/json' },
		method: "POST",
		signal
	}

	return genericFetch<BergerlevraultLocalauthority[]>(url, init)
}

export function getAxesAnalytiques(
	server: string,
	port: number,
	idCollectiviteGF: number,
	signal: AbortSignal
): Promise<AxeAnalytique[]> {
	const url: string = `${apiBaseUrl}/${BLS}/${AXES}`
	const infos: any = {
		port,
		server,
		idCollectiviteGF
	}
	const body = JSON.stringify(infos)
	const init: RequestInit = {
		body,
		headers: { ...getBaseHeader(), 'Content-Type': 'application/json' },
		method: "POST",
		signal
	}
	return genericFetch<AxeAnalytique[]>(url, init)
}

export function getBudgets(
	server: string,
	port: number,
	idCollectiviteGF: number,
	signal: AbortSignal
): Promise<Budget[]> {
	const url: string = `${apiBaseUrl}/${BLS}/${BUDGETS}`
	const infos: any = {
		port,
		server,
		idCollectiviteGF
	}
	const body = JSON.stringify(infos)
	const init: RequestInit = {
		body,
		headers: { ...getBaseHeader(), 'Content-Type': 'application/json' },
		method: "POST",
		signal
	}
	return genericFetch<Budget[]>(url, init)
}



// WEBPACK FOOTER //
// ./src/service/sfp/berger-levrault-ws-service.ts